import React from 'react'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'

export default function SmartviewHeader (props) {
  if (props.children) {
    return (
      <>
        <div className='text-xl font-medium'>
          {props.children}
        </div>
        <SmartviewContentSeparator />
      </>
    )
  }

  return null
}
